import type {
    INormalItemProps,
    TransformCartItem,
} from "@swiggy-private/dls-web-recipe-common-web/dist/components/FoodItem/types";
import type { ILocalCart } from "@swiggy-private/portal-dineout-context";

export const getCartItemFromLocalCart = (id: string, localCart: ILocalCart) => {
    try {
        const finalCartItem: {
            items: TransformCartItem["items"];
            quantity: number;
            itemId?: number;
        } = {
            items: [],
            quantity: 0,
        };

        const cartItem = localCart.cartItems.find((item) => item.menu_item_id === id);
        const cartItems = localCart.cartItems.filter((item) => item.menu_item_id === id);
        if (cartItem) {
            finalCartItem.itemId = Number(cartItem.menu_item_id);
            finalCartItem.items = cartItems.map((item) => ({
                ...item,
                addons: (item.addons ?? []).flatMap((addon) =>
                    (addon.choices ?? []).map((choice) => ({
                        choice_id: choice.id,
                        choiceId: choice.id,
                        groupId: addon.groupId,
                        group_id: addon.groupId,
                        name: choice.name,
                    }))
                ),
                variants: [],
            }));
            finalCartItem.quantity = cartItems.reduce((acc, item) => acc + item.quantity, 0);
        }
        return finalCartItem as INormalItemProps["cartItem"];
    } catch (_) {
        // no-ops
    }
};
